module.exports = __webpack_public_path__ + "f44a5a206c38446ffe694f57a77cf6ea.jpg";